export default "__VITE_ASSET__kOwv9s6F__"